import React, { useState } from 'react';

import { ParsedQuery } from 'query-string';
import { useHistory } from 'react-router-dom';

import * as Api from '../api/api';
import * as WebRoutes from '../web-routes';

import { LoadingMessage } from '../widgets/loading-message';

export const SalesforceAccountLookupRedirect = ({ queryParams }: { queryParams: ParsedQuery }) => {
  const { salesforceId } = queryParams;
  const history = useHistory();
  const [requestError, setRequestError] = useState<string>('');

  if (!salesforceId) {
    return (
      <div className="typo-h5 u-margin-top-2x u-textAlign-center">
        Salesforce accountId required.
      </div>
    );
  }

  if (requestError) {
    return <div className="typo-h5 u-margin-top-2x u-textAlign-center">{requestError}</div>;
  }

  Api.get(`/salesforce-account-lookup?salesforceId=${salesforceId}`)
    .then((response) => response.json())
    .then(({ orgId, errorMessage }) => {
      if (orgId) {
        history.replace(WebRoutes.orgRoute(orgId));
        return;
      }

      const error =
        errorMessage || `Unhandled error on salesforce redirect with salesforceId ${salesforceId}`;
      setRequestError(error);
    });

  return <LoadingMessage />;
};
